"use client";

/**
 * PORTED — RO-11-02 / #44587.
 * Origin: `excellent/app/_chrome/play-button.tsx`.
 * No next/* imports — verbatim.
 */

import { Play } from "@excellent/ui/icons";
import { Button, Tooltip, TooltipContent, TooltipTrigger, usePlayLaunch } from "@excellent/ui";

/**
 * The global "Play" button — the primary "go to work" surface, above the modes
 * (Three-Layer PRD §3.2). Icon-only primary in the toolbar grammar (`default` +
 * `icon-tb`, the same pairing as the create "+" in `SectionActions` clusters) so
 * the nav's right cluster reads like the section action rows. The solid play
 * glyph reads as the conventional "go" triangle, shrunk a step below the atom's
 * 14px stroke-icon standard because a filled triangle carries more visual weight;
 * the tooltip + aria-label carry the wording.
 *
 * The dialog itself + the ⌘⏎ shortcut live in `AppPlayLaunchProvider` (the root
 * layout) so the button, the shortcut, and the Pulse spine's empty-band CTAs all
 * open ONE shared Play interface.
 */
export function PlayButton() {
  const { launch } = usePlayLaunch();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size="icon-tb-tight"
          aria-label="Play — what to do next"
          onClick={() => launch()}
        >
          <Play strokeWidth={1.5} className="fill-current" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">What to do next</TooltipContent>
    </Tooltip>
  );
}
